import RangeSlider from 'react-range-slider-input'
import 'react-range-slider-input/dist/style.css'
import './Range.Style.css'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import { formatNumber } from '../../../../../utility'

export type RangeProps = {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  step?: number
  leftLabel?: string
  rightLabel?: string
  hidePercentage?: boolean
  labelClassName?: string
  small?: boolean
  percentageSuffix?: string
  customCurrentValueLabel?: string | React.ReactNode
  marker?: number[] | false
}

const Range: React.FC<RangeProps> = ({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 5,
  leftLabel,
  rightLabel,
  hidePercentage = false,
  labelClassName = '',
  small = false,
  percentageSuffix,
  customCurrentValueLabel,
  marker = false,
}) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const update = (value: number[]) => {
    onChange(value[1])
  }

  const getMarkerPosition = (value: number) => {
    const position = (100 / max) * (value || 0.1)
    return position
  }

  return (
    <div className="w-full relative immoraum">
      <RangeSlider
        className={`single-thumb ${small && 'small'}`}
        thumbsDisabled={[true, false]}
        rangeSlideDisabled={true}
        value={[0, value || 0]}
        onInput={update}
        max={max}
        min={min}
        step={step}
      />
      <div className="w-full relative">
        {Array.isArray(marker) &&
          marker.map((m, i) => (
            <div
              key={i}
              style={{ left: `calc(${getMarkerPosition(m)}% - 5.5% - (15px / 100 * ${100 - getMarkerPosition(m)}))` }}
              className={`absolute cursor-none h-4 w-4 rounded-full bg-white border-2 border-graySecondary -top-[9px]`}
            >
              <div className="absolute -top-7 left-1/2 -translate-x-1/2 text-black">{formatNumber(getMarkerPosition(m) / 100)}</div>
            </div>
          ))}
      </div>
      <div>
        <div className="flex flex-row mt-1 relative">
          <div className={`truncate flex-1 text-xs md:text-sm text-gray ${labelClassName}`}>{leftLabel || ''}</div>
          {!hidePercentage && (
            <div
              className={`absolute left-1/2 -translate-x-1/2 truncate flex-1 text-center text-black ${
                small ? 'text-sm font-bold mt-3' : 'text-sm md:text-md font-bold mt-6'
              } ${labelClassName}`}
            >
              {!customCurrentValueLabel && value > 0 ? `${formatNumber(value)}${percentageSuffix || t.generic.percent}` : ''}
              {customCurrentValueLabel && customCurrentValueLabel}
            </div>
          )}
          <div className={`truncate flex-1 text-right text-xs md:text-sm text-gray ${labelClassName}`}>{rightLabel || ''}</div>
        </div>
      </div>
    </div>
  )
}

export default Range
